import { UNIONS_A } from './unions-a';
import { UNIONS_B } from './unions-b';
import { UNIONS_C } from './unions-c';
import type { PoolWeapon } from './weapons-pool';
/* ============================================================
   融合（Union）
   ============================================================

   照 VS 官方 wiki 的 Evolution 頁做的。那一頁講的其實是**兩套機制**，
   我們原本只做了前者：

     進化 Evolution：滿級武裝 + 指定被動 → 換一把新的。被動不消耗
     融合 Union    ：**兩把都滿級的武裝合成一把**，而且**空出一個武器槽**

   > "a union is a combination of two weapons ... two weapons are merged into one,
   >  hence emptying a weapon slot"

   空出槽位是融合的靈魂，不是附帶效果：它讓「把兩把練滿」從
   「佔掉兩格的貪心」變成「先擠後鬆」的節奏 —— 融合完你多一格可以再拿新東西。
   沒有這一條的話，融合只是一個名字比較長的進化。

   每一個融合都選在**行為改變**而不是數值放大（同進化的原則），
   而且要說得出「這兩把單獨做不到的是什麼」——
   否則玩家會覺得自己只是把兩把武裝換成一把比較強的。

   ## 2026-08-05 第二批：2 → 8 個，而且刻意做成**一對多**

   進化是「一把武裝 + 一個鑰匙被動」，路線數受限於被動槽（6 格）；
   融合只要「兩把都滿級」，所以它才是後期真正還開得出來的質變 ——
   而在這之前只有 2 個組合，玩家沒抽到那四把就整場都碰不到融合。

   第二批之後每一把池子武裝都參與**至少兩條**質變路線（04 的驗收條件）：

     w-orbit    斬空領域（進化）／絞盤領域・斬輪（融合 ×2）
     w-orbital  軌道支配（進化）／光柵陣列・重力攻城（融合 ×2）
     w-tether   **沒有進化**（它不造成傷害，量測台的「來源零輸出」會擋）
                → 重力雷區・重力攻城兩個融合

   `w-tether` 那一條是刻意的：整個池子裡唯一不輸出的武裝，
   它的價值本來就只在「跟別的東西一起用」，融合是它天生的出口。

   ## 2026-08-05 融合也有等級了（`CRAFT_MAX = 3`）

   Lv1 從寶箱拿（＝原本那一級，數值一字未動），Lv2/Lv3 走升級選單。
   理由與施工契約見 `data/evolutions.ts` 檔頭與 `.claude/notes/craft-levels.md`。
   融合的升級**不會再吃掉一個槽**：吃兩把放回一把只發生在 Lv1 那一次。 */

export type Union = PoolWeapon & { union: { a: string, b: string } };

export var UNIONS: Union[] = UNIONS_A.concat(UNIONS_B).concat(UNIONS_C);

export function unionById(id) {
  for (var i = 0; i < UNIONS.length; i++) if (UNIONS[i].id === id) return UNIONS[i];
  return null;
}

/** 這個武裝是不是某個融合的來源（用來在說明上提示玩家）。
    **回傳第一個** —— 一對多之後這只夠做提示，要列全部請用 `unionsUsing`。 */
export function unionUsing(weaponId) {
  for (var i = 0; i < UNIONS.length; i++) {
    if (UNIONS[i].union.a === weaponId || UNIONS[i].union.b === weaponId) return UNIONS[i];
  }
  return null;
}

/** 這把武裝參與的所有融合。給說明文字與圖鑑用。 */
export function unionsUsing(weaponId) {
  var out: Union[] = [];
  for (var i = 0; i < UNIONS.length; i++) {
    if (UNIONS[i].union.a === weaponId || UNIONS[i].union.b === weaponId) out.push(UNIONS[i]);
  }
  return out;
}
